export default __webpack_public_path__ + "f7cadad0b3786c077609c35c45d38171.svg";